"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AuthorizationError = void 0;
exports.isAuthorizationError = isAuthorizationError;
const authentication_errors_1 = require("./authentication.errors");
class AuthorizationError extends authentication_errors_1.AuthError {
    constructor(action, resource) {
        super(`Cannot ${action} on ${resource.kind}:${resource.id}`);
        this.action = action;
        this.resource = resource;
    }
}
exports.AuthorizationError = AuthorizationError;
function isAuthorizationError(error) {
    return error instanceof AuthorizationError;
}
//# sourceMappingURL=authorization.errors.js.map